<template>
    <div class="tooltip-notification-container">
        <NotificationItem
            v-for="item in notificationItems"
            :key="item.id"
            :id="item.id"
            :title="item.title"
            :img="item.img"
        />
    </div>
</template>

<script>
import NotificationItem from "./NotificationItem.vue";

export default {
    name: 'Notifications',
    components: {
        NotificationItem,
        Notification,
    },
    data () {
        return {
            notificationItems: [
                {
                    id: 'mollie',
                    title: 'Mollie',
                    img: 'src/cms/img/widgets/mollie.jpeg',
                },
                {
                    id: 'dell',
                    title: 'Dell',
                    img: 'src/cms/img/widgets/dell.png',
                },
                {
                    id: 'exactProduct',
                    title: 'Product',
                    img: 'src/cms/img/widgets/exact.jpg',
                },
                {
                    id: 'exactBulkPurchase',
                    title: 'Stock',
                    img: 'src/cms/img/widgets/exact.jpg',
                },
                {
                    id: 'exactUser',
                    title: 'User',
                    img: 'src/cms/img/widgets/exact.jpg',
                },
                {
                    id: 'exactOrder',
                    title: 'Order',
                    img: 'src/cms/img/widgets/exact.jpg',
                },
                {
                    id: 'hp',
                    title: 'Hp',
                    img: 'src/cms/img/widgets/hp.png',
                },
                {
                    id: 'rlc',
                    title: 'Rlc',
                    img: 'src/cms/img/widgets/rlc.jpeg',
                }
            ],
        };
    }
}
</script>
